import { AbstractSubmitStep } from "@component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import { faCircleDot as farCircleDot } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import {
	faChild as fasChild,
	faPlus as fasPlus,
	faSuitcaseMedical as fasSuitcaseMedical,
	faArrowRight as fasArrowRight,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormDecidable, FormSelect, ProgressButton } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";
import type { LoanGoal } from "./Step2.data";
import { LOAN_GOALS, NUMBER_OF_CHILDREN, NUMBER_OF_CHILDREN_COMMITMENT, SOCIAL_INSURANCE_SINCE } from "./Step2.data";

export interface StepFields {
	loanGoal: LoanGoal;
	married: boolean;
	numberOfChildren: number;
	numberOfChildrenCommitment: number;
	taxDept: boolean;
	socialInsuranceSinceId: string;
}

export class Step2 extends AbstractSubmitStep<StepFields> {
	protected initValues(): StepFields {
		return {
			loanGoal: undefined,
			married: undefined,
			numberOfChildren: undefined,
			numberOfChildrenCommitment: undefined,
			taxDept: undefined,
			socialInsuranceSinceId: undefined,
		};
	}

	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { submitState } = this.props;
		const disabled = this.isDisabled();

		return (
			<>
				<Card.Body>
					<FormSelect
						label="Mire fordítanád a támogatást?"
						name="loanGoal"
						placeholder="Kérjük, válassz!"
						prepend={<FontAwesomeIcon icon={farCircleDot} />}
						options={LOAN_GOALS} // TODO: BM_API_URL . '/api/public/loan-goals/csok'
						disabled={disabled}
						required
					/>
					<FormDecidable label="Házasként igényled a támogatást" name="married" required />
					<FormSelect
						label="Hány gyermeked van jelenleg?"
						name="numberOfChildren"
						placeholder="Kérjük, válassz!"
						prepend={<FontAwesomeIcon icon={fasChild} />}
						infoTooltip="Csak olyan vér szerinti vagy örökbefogadott gyermek után igényelhető támogatás, aki nem töltötte be a 25. életévét, vagy már betöltötte a 25. életévét, de megváltozott munkaképességű. Meglévő gyermeknek számít a magzat vagy ikermagzat is a terhesség betöltött 12. hetét követően."
						options={NUMBER_OF_CHILDREN}
						disabled={disabled}
						required
					/>
					<FormSelect
						label="Hány gyermeket szeretnél még?"
						name="numberOfChildrenCommitment"
						placeholder="Kérjük, válassz!"
						prepend={<FontAwesomeIcon icon={fasPlus} />}
						infoTooltip="Azon házaspárok, akiknél legalább az egyik fél nem töltötte be a 40. életévét, további gyermek(ek)et vállalhatnak, akik után szintén igénybe vehetik a támogatást."
						options={NUMBER_OF_CHILDREN_COMMITMENT}
						disabled={disabled}
						required
					/>
					<FormDecidable
						label="Van adótartozásod?"
						name="taxDept"
						infoTooltip="Például jövedelemadó, súlyadó, stb."
						disabled={disabled}
						required
					/>
					<FormSelect
						label="Hány év folyamatos TB biztosításod van?"
						name="socialInsuranceSinceId"
						placeholder="Kérjük, válassz!"
						prepend={<FontAwesomeIcon icon={fasSuitcaseMedical} />}
						infoTooltip="TB biztosítást házas- vagy élettársak közül legalább az egyik félnek igazolnia kell (külföldi igazolás is megfelel)."
						options={SOCIAL_INSURANCE_SINCE} // TODO: BM_API_URL . '/api/public/master-data/social-insurance-sinces'
						disabled={disabled}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
						state={submitState}
					>
						Tovább
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step2";
	}
}
